export default __webpack_public_path__ + "static/gs-2b-reviewgeneratedcode--mobile-5ddf7b34ee493c0bfabb1401127ed181.jpg";